<template>
  <z-action-picker
    v-model="wearPopupStatus"
    get-container="body"
    v-zpm="{
      sectionid: 109,
      areaexposure: 109,
      legoareabackup: {
        sortName: '佩戴效果'
      }
    }"
    :show-btn="false"
    height="80vh"
    title="佩戴效果"
    @confirm="openWearPopup"
    @click-overlay="openWearPopup"
  >
    <WatchIntro :goodsInfo="dataInfo" :eventBus="{}" />
  </z-action-picker>
</template>

<script>
import Vue from 'vue'
// import { defineComponent, computed, ref } from '@vue/composition-api'
import { defineComponent, ref } from '@vue/composition-api'

import { ActionPicker } from '@zz-common/zz-ui'
import WatchIntro from '../GoodsIntro/Watch/WatchIntro.vue'
Vue.use(ActionPicker)

export default defineComponent({
  components: {
    WatchIntro
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    const wearPopupStatus = ref(false) // 佩戴效果弹窗
    const selectedWatch = ref(null)

    /**
     * $ 佩戴效果弹窗
     */
    // TODO: 二奢融合 佩戴效果弹窗
    const openWearPopup = () => {
      wearPopupStatus.value = !wearPopupStatus.value
    }

    /**
     * $ 腕表切换
     */
    const selectWear = (item, index) => {
      selectedWatch.value = index
    }

    return {
      wearPopupStatus,
      openWearPopup,
      // selectedWatch,
      selectWear
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';

.pedia-list {
  padding: 32px;
  .tab-list {
    display: flex;
    height: 140px;
    .tab-list-item {
      position: relative;
      width: 108px;
      margin-right: 36px;
    }
  }
}
</style>
